import {
  SEARCH_APPEARS_ON_FILTER_FIELD,
  SEARCH_TRACK_TAGS_FILTER_FIELD,
} from '@disco/constants/search'

import type { FilterDefinition } from 'types/filter-page'

// Shared by the filter bar and the in-table controls editing the same `filters`
// entry. Apart from ./config, which wires up the filter form components.

export const APPEARS_ON_FILTER_DEFINITION: FilterDefinition = {
  label: 'Appears on',
  type: 'number',
  field: SEARCH_APPEARS_ON_FILTER_FIELD,
  isNew: true,
}

export const TAGS_FILTER_DEFINITION: FilterDefinition = {
  label: 'Tags',
  type: 'tags',
  field: SEARCH_TRACK_TAGS_FILTER_FIELD,
}
